import { useSiteContent } from "../context/SiteContentContext";
import { useLanguage } from "../context/LanguageContext";

/**
 * Returns a getter function that reads dynamic site_settings keys with
 * a fallback object {sq, en} per the current language. Reactive — components
 * automatically re-render when language changes.
 *
 *   const text = useSiteText();
 *   text("home.hero.title", { sq: "Default SQ", en: "Default EN" })
 *   text("contact.phone", "+355...")  // single string fallback
 */
const useSiteText = () => {
  const { settings } = useSiteContent();
  const { lang } = useLanguage();

  return (key, fallback) => {
    const v = settings[key];
    if (v && typeof v === "object") {
      if (v.value !== undefined && v.value !== null && v.value !== "") return v.value;
      if (v[lang] !== undefined && v[lang] !== null && v[lang] !== "") return v[lang];
    }
    if (fallback && typeof fallback === "object") return fallback[lang] ?? "";
    return fallback ?? "";
  };
};

export default useSiteText;
